import React from "react";
import { useNavigate } from "react-router-dom";
import { fonts } from "../theme";
import { View, Text, Button } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";

const HERO = "https://images.unsplash.com/photo-1704701238816-7111eb8200df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Welcome() {
  const navigate = useNavigate();
  const { tr, lang, setLang } = useI18n();
  return (
    <View style={{ minHeight: "100vh", backgroundColor: "#0F2540", position: "relative" }}>
      <div style={{ position: "absolute", inset: 0, backgroundImage: `url(${HERO})`, backgroundSize: "cover", backgroundPosition: "center" }} />
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(rgba(15,37,64,0.25), rgba(15,37,64,0.55) 45%, rgba(15,37,64,0.96))" }} />
      <View style={{ position: "relative", minHeight: "100vh", justifyContent: "space-between", padding: "0 28px" }}>
        <View row style={{ paddingTop: 24, justifyContent: "flex-end" }}>
          <View row style={{ backgroundColor: "rgba(255,255,255,0.16)", borderRadius: 999, padding: 4 }}>
            {["de", "en"].map((l) => (
              <div key={l} data-testid={`welcome-lang-${l}`} onClick={() => setLang(l)} style={{
                padding: "6px 14px", borderRadius: 999, cursor: "pointer",
                backgroundColor: lang === l ? "#FFFFFF" : "transparent",
              }}>
                <span style={{ fontWeight: fonts.bold, fontSize: 13, color: lang === l ? "#0F2540" : "#FFFFFF" }}>{l.toUpperCase()}</span>
              </div>
            ))}
          </View>
        </View>
        <View style={{ alignItems: "center", marginTop: 40 }}>
          <View style={{ marginBottom: 8 }}><Icon name="cap" size={34} color="#FFFFFF" weight="fill" /></View>
          <Text style={{ fontWeight: 800, fontSize: 44, color: "#FFFFFF", letterSpacing: 2 }}>MELLY</Text>
          <Text style={{ fontWeight: fonts.medium, fontSize: 16, color: "rgba(255,255,255,0.85)", letterSpacing: 8, marginTop: 2 }}>LEADERSHIP</Text>
        </View>
        <View style={{ paddingBottom: 40 }}>
          <Text style={{ fontWeight: fonts.bold, fontSize: 24, color: "#FFFFFF", marginBottom: 6 }}>{tr("welcomeTagline")}</Text>
          <Text style={{ fontWeight: fonts.regular, fontSize: 16, color: "rgba(255,255,255,0.82)", marginBottom: 24 }}>{tr("welcomeSub")}</Text>
          <Button testID="get-started-btn" title={tr("getStarted")} onPress={() => navigate("/login")} iconRight="arrow-right" />
        </View>
      </View>
    </View>
  );
}
